<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-large">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
      </header>
      <section class="modal-card-body">
        <div class="notification is-danger" v-if="error !== ''">{{ error }}</div>
        <p class="control">
          <label class="label">Name</label>
          <input :class="{'input': true, 'is-danger': errors.has('name'), 'is-disabled': inProgress}" type="text" name="name" id="name" placeholder="Name" v-model="agency.name" v-validate="'required'">
          <span v-show="errors.has('name')" class="help is-danger">{{ errors.first('name') }}</span>
        </p>
        <p class="control">
          <label class="label">Nationality</label>
          <select class="select is-fullwidth" v-model="agency.national" name="national" id="national" @change="nationality">
            <option value="1">Nacional</option>
            <option value="0">Internacional</option>
          </select>
        </p>
        <p class="control">
          <label class="label">Email</label>
          <input :class="{'input': true, 'is-danger': errors.has('email'), 'is-disabled': inProgress}" type="email" name="email" id="email" placeholder="Email" v-model="agency.email" v-validate="'required|email'">
          <span v-show="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</span>
        </p>
        <p class="control" v-if="agency_id === null">
          <label class="label">Password</label>
          <input :class="{'input': true, 'is-danger': errors.has('password'), 'is-disabled': inProgress}" type="password" name="password" id="password" placeholder="Password" v-model="agency.password" v-validate="'required'">
          <span v-show="errors.has('password')" class="help is-danger">{{ errors.first('password') }}</span>
        </p>
        <p class="control">
          <label class="label">Social Reason</label>
          <input :class="{'input': true, 'is-danger': errors.has('social_reason'), 'is-disabled': inProgress}" type="text" name="social_reason" id="social_reason" placeholder="Social Reason" v-model="agency.social_reason" v-validate="'required'">
          <span v-show="errors.has('social_reason')" class="help is-danger">{{ errors.first('social_reason') }}</span>
        </p>
        <p class="control" v-show="showCep">
          <label class="label">CNPJ</label>
          <input :class="{'input': true, 'is-danger': errors.has('cnpj'), 'is-disabled': inProgress}" type="text" name="cnpj" id="cnpj" placeholder="CNPJ" v-model="agency.cnpj" v-validate="{ required: parseInt(agency.national) ==! 0, numeric: true }">
          <span v-show="errors.has('cnpj')" class="help is-danger">{{ errors.first('cnpj') }}</span>
        </p>
        <p class="control" v-show="showCep">
          <label class="label">Municipal Inscription</label>
          <input :class="{'input': true, 'is-danger': errors.has('municipal_inscription'), 'is-disabled': inProgress}" type="text" name="municipal_inscription" id="municipal_inscription" placeholder="Municipal Inscription" v-model="agency.municipal_inscription" v-validate="'numeric'">
          <span v-show="errors.has('municipal_inscription')" class="help is-danger">{{ errors.first('municipal_inscription') }}</span>
        </p>
        <p class="control" v-show="parseInt(context.$store.state.config.user.level) < 4 && parseInt(agency.national) === 1">
          <label class="checkbox">
            <input type="checkbox" v-model="agency.nf">
            NFS-e
          </label>
        </p>
        <p class="control" v-show="parseInt(context.$store.state.config.user.level) < 4">
          <label class="checkbox">
            <input type="checkbox" v-model="agency.commission">
            Commission <input :class="{'input': true, 'is-danger': errors.has('commission'), 'is-disabled': agency.commission ? false : true}" type="text" name="commission_value" id="commission_value" v-model="agency.commission_value" style="width: 4rem; vertical-align: middle;"> %
          </label>
        </p>
        <div v-if="(parseInt(context.$store.state.config.user.level) < 4) && parseInt(agency.national) === 1" style="margin-bottom: 0.5rem">
          <p class="control">
            <input type="checkbox" v-model="agency.boleto" @click="setBoleto">
            Boleto
            <span v-if="(agency.boleto === 1 || agency.boleto === true)" style="margin-left: 3rem;">
              Negativação (1~30) <input :class="{'input': true, 'is-danger': errors.has('negativacao'), 'is-disabled': inProgress}"
                              type=""
                              name="negativacao"
                              id="negativacao"
                              v-model="agency.negativacao"
                              v-validate="'required|numeric|max_value:30'" style="width: 2.5rem; vertical-align: middle;"> days
            </span>
            <span v-show="errors.has('negativacao')" class="help is-danger">{{ errors.first('negativacao') }}</span>
            <span v-if="(agency.boleto === 1 || agency.boleto === true)" style="margin-left: 3rem;">
              Protesto (2~30) <input :class="{'input': true, 'is-danger': errors.has('protesto'), 'is-disabled': inProgress}"
                              type=""
                              name="protesto"
                              id="protesto"
                              v-model="agency.protesto"
                              v-validate="'required|numeric|max_value:30'" style="width: 2.5rem; vertical-align: middle;"> days
            </span>
            <span v-show="errors.has('protesto')" class="help is-danger">{{ errors.first('protesto') }}</span>
          </p>
          <p class="control" v-if="(agency.boleto === 1 || agency.boleto === true)">
            <label class="label">Banco</label>
            <select class="select is-fullwidth" v-model="agency.banco" name="banco" id="banco" v-validate="'required|min_value:1'">
              <option value="0">Escolha um banco para emissão do boleto</option>
              <option value="1">Bradesco</option>
              <option value="2">Santander</option>
              <option value="3">Itau</option>
            </select>
          </p>
          <span v-show="errors.has('banco')" class="help is-danger">Necessário escolher um banco para emissão do boleto</span>
        </div>
        <div v-if="(parseInt(context.$store.state.config.user.level) < 4)">
          <input type="checkbox" v-model="agency.card" @click="setCard"> Cartão
        </div>
        <p class="control" v-show="parseInt(context.$store.state.config.user.level) < 4">
          <label class="label">Incentive</label>
          <select class="select" v-model="agency.incentive_type" name="incentive_type" id="incentive_type">
            <option value="0">None</option>
            <option value="1">Percentage</option>
            <option value="2">Value</option>
          </select>
          <input :class="{'input': true, 'is-danger': errors.has('incentive_value'), 'is-disabled': parseInt(agency.incentive_type) !== 0 ? false : true}" type="text" name="incentive_value" id="incentive_value" v-model="agency.incentive_value" style="width: 4rem; vertical-align: middle;">
        </p>
        <p class="control" v-show="parseInt(context.$store.state.config.user.level) < 4">
          <label class="label">Invoice Automatic Send</label>
          <select class="select" v-model="agency.invoice_send" name="invoice_send" id="invoice_send">
            <option value="0">None</option>
            <option value="1">D+1</option>
          </select>
        </p>
        <div class="control is-vertical">
          <div class="control is-grouped">
            <p class="control is-expanded">
              <label class="label">Phone</label>
              <input :class="{'input': true, 'is-danger': errors.has('phone'), 'is-disabled': inProgress}" type="text" name="phone" id="phone" placeholder="Phone" v-model="agency.phone" v-validate="'required'">
              <span v-show="errors.has('phone')" class="help is-danger">{{ errors.first('phone') }}</span>
            </p>
            <p class="control is-expanded">
              <label class="label">Emergency Phone</label>
              <input :class="{'input': true, 'is-danger': errors.has('emergency_phone'), 'is-disabled': inProgress}" type="text" name="emergency_phone" id="emergency_phone" placeholder="Emergency Phone" v-model="agency.emergency_phone">
              <span v-show="errors.has('emergency_phone')" class="help is-danger">{{ errors.first('emergency_phone') }}</span>
            </p>
          </div>
        </div>
        <p class="control" v-show="showCep">
          <label class="label">CEP</label>
          <input :class="{'input': true, 'is-danger': errors.has('cep'), 'is-disabled': inProgress}" type="cep" name="cep" id="cep" placeholder="CEP" v-model="agency.cep" @change="cep" v-validate="{ required: parseInt(agency.national) ==! 0, numeric: true }">
          <span v-show="errors.has('cep')" class="help is-danger">{{ errors.first('cep') }}</span>
        </p>
        <div class="control is-vertical">
          <div class="control is-grouped">
            <p class="control is-expanded">
              <label class="label">Address</label>
              <input :class="{'input': true, 'is-danger': errors.has('address'), 'is-disabled': inProgress || (cepProgress && parseInt(agency.national) === 1)}" type="text" name="address" id="address" placeholder="Address" v-model="agency.address" v-validate="'required'">
              <span v-show="errors.has('address')" class="help is-danger">{{ errors.first('address') }}</span>
            </p>
            <p class="control is-expanded">
              <label class="label">Address Number</label>
              <input :class="{'input': true, 'is-danger': errors.has('address_number'), 'is-disabled': inProgress ||(cepProgress && parseInt(agency.national) === 1)}" type="text" name="address_number" id="address_number" placeholder="Address Number" v-model="agency.address_number" v-validate="'required'">
              <span v-show="errors.has('address_number')" class="help is-danger">{{ errors.first('address_number') }}</span>
            </p>
            <p class="control is-expanded">
              <label class="label">Neighborhood</label>
              <input :class="{'input': true, 'is-danger': errors.has('address_neighborhood'), 'is-disabled': inProgress || (cepProgress && parseInt(agency.national) === 1)}" type="text" name="address_neighborhood" id="address_neighborhood" placeholder="Neighborhood" v-model="agency.address_neighborhood" v-validate="'required'">
              <span v-show="errors.has('address_neighborhood')" class="help is-danger">{{ errors.first('address_neighborhood') }}</span>
            </p>
          </div>
        </div>
        <p class="control is-expanded">
          <label class="label">Address Complement</label>
          <input :class="{'input': true, 'is-danger': errors.has('address_complement'), 'is-disabled': inProgress}" type="text" name="address_complement" id="address_complement" placeholder="Address Complement" v-model="agency.address_complement">
          <span v-show="errors.has('address_complement')" class="help is-danger">{{ errors.first('address_complement') }}</span>
        </p>
        <div class="control is-vertical">
          <div class="control is-grouped">
            <p class="control is-expanded">
              <label class="label">City</label>
              <input :class="{'input': true, 'is-danger': errors.has('city'), 'is-disabled': inProgress || (cepProgress && parseInt(agency.national) === 1)}" type="text" name="city" id="city" placeholder="City" v-model="agency.city" v-validate="'required'">
              <span v-show="errors.has('city')" class="help is-danger">{{ errors.first('city') }}</span>
            </p>
            <p class="control is-expanded" v-show="showCep">
              <label class="label">IBGE</label>
              <input :class="{'input': true, 'is-danger': errors.has('cmun'), 'is-disabled': inProgress || (cepProgress && parseInt(agency.national) === 1)}" type="text" name="cmun" id="cmun" placeholder="" v-model="agency.cmun" v-validate="{ required: parseInt(agency.national) ==! 0}">
              <span v-show="errors.has('cmun')" class="help is-danger">{{ errors.first('cmun') }}</span>
            </p>
            <p class="control is-expanded">
              <label class="label">State</label>
              <input :class="{'input': true, 'is-danger': errors.has('state'), 'is-disabled': inProgress || (cepProgress && parseInt(agency.national) === 1)}" type="text" name="state" id="state" placeholder="State" v-model="agency.state" v-validate="'required'">
              <span v-show="errors.has('state')" class="help is-danger">{{ errors.first('state') }}</span>
            </p>
            <p class="control is-expanded">
              <label class="label">Country</label>
              <input :class="{'input': true, 'is-danger': errors.has('country'), 'is-disabled': inProgress || (cepProgress && parseInt(agency.national)=== 1)}" type="text" name="country" id="country" placeholder="Country" v-model="agency.country" v-validate="'required'">
              <span v-show="errors.has('country')" class="help is-danger">{{ errors.first('country') }}</span>
            </p>
          </div>
        </div>
        <p class="control">
          <label class="label">Site</label>
          <input :class="{'input': true, 'is-danger': errors.has('website'), 'is-disabled': inProgress}" type="text" name="website" id="website" placeholder="Site" v-model="agency.website">
          <span v-show="errors.has('website')" class="help is-danger">{{ errors.first('website') }}</span>
        </p>
        <p class="control">
          <label class="label">Payment</label>
          <select class="select is-fullwidth" v-model="agency.payment" name="payment" id="payment">
            <option v-for="payment in context.$store.state.config.agency.payment" v-bind:value="payment.id" :key="payment.id">{{ payment.name }}</option>
          </select>
        </p>
        <p class="control">
          <label class="label">Timezone</label>
          <select name="timezone" id="timezone" class="is-fullwidth" v-model="agency.timezone">
            <option value="-12:00">(GMT -12:00) Eniwetok, Kwajalein</option>
            <option value="-11:00">(GMT -11:00) Midway Island, Samoa</option>
            <option value="-10:00">(GMT -10:00) Hawaii</option>
            <option value="-09:50">(GMT -9:30) Taiohae</option>
            <option value="-09:00">(GMT -9:00) Alaska</option>
            <option value="-08:00">(GMT -8:00) Pacific Time (US &amp; Canada)</option>
            <option value="-07:00">(GMT -7:00) Mountain Time (US &amp; Canada)</option>
            <option value="-06:00">(GMT -6:00) Central Time (US &amp; Canada), Mexico City</option>
            <option value="-05:00">(GMT -5:00) Eastern Time (US &amp; Canada), Bogota, Lima</option>
            <option value="-04:50">(GMT -4:30) Caracas</option>
            <option value="-04:00">(GMT -4:00) Atlantic Time (Canada), Caracas, La Paz</option>
            <option value="-03:50">(GMT -3:30) Newfoundland</option>
            <option value="-03:00">(GMT -3:00) Brazil, Buenos Aires, Georgetown</option>
            <option value="-02:00">(GMT -2:00) Mid-Atlantic</option>
            <option value="-01:00">(GMT -1:00) Azores, Cape Verde Islands</option>
            <option value="+00:00">(GMT) Western Europe Time, London, Lisbon, Casablanca</option>
            <option value="+01:00">(GMT +1:00) Brussels, Copenhagen, Madrid, Paris</option>
            <option value="+02:00">(GMT +2:00) Kaliningrad, South Africa</option>
            <option value="+03:00">(GMT +3:00) Baghdad, Riyadh, Moscow, St. Petersburg</option>
            <option value="+03:50">(GMT +3:30) Tehran</option>
            <option value="+04:00">(GMT +4:00) Abu Dhabi, Muscat, Baku, Tbilisi</option>
            <option value="+04:50">(GMT +4:30) Kabul</option>
            <option value="+05:00">(GMT +5:00) Ekaterinburg, Islamabad, Karachi, Tashkent</option>
            <option value="+05:50">(GMT +5:30) Bombay, Calcutta, Madras, New Delhi</option>
            <option value="+05:75">(GMT +5:45) Kathmandu, Pokhara</option>
            <option value="+06:00">(GMT +6:00) Almaty, Dhaka, Colombo</option>
            <option value="+06:50">(GMT +6:30) Yangon, Mandalay</option>
            <option value="+07:00">(GMT +7:00) Bangkok, Hanoi, Jakarta</option>
            <option value="+08:00">(GMT +8:00) Beijing, Perth, Singapore, Hong Kong</option>
            <option value="+08:75">(GMT +8:45) Eucla</option>
            <option value="+09:00">(GMT +9:00) Tokyo, Seoul, Osaka, Sapporo, Yakutsk</option>
            <option value="+09:50">(GMT +9:30) Adelaide, Darwin</option>
            <option value="+10:00">(GMT +10:00) Eastern Australia, Guam, Vladivostok</option>
            <option value="+10:50">(GMT +10:30) Lord Howe Island</option>
            <option value="+11:00">(GMT +11:00) Magadan, Solomon Islands, New Caledonia</option>
            <option value="+11:50">(GMT +11:30) Norfolk Island</option>
            <option value="+12:00">(GMT +12:00) Auckland, Wellington, Fiji, Kamchatka</option>
            <option value="+12:75">(GMT +12:45) Chatham Islands</option>
            <option value="+13:00">(GMT +13:00) Apia, Nukualofa</option>
            <option value="+14:00">(GMT +14:00) Line Islands, Tokelau</option>
          </select>
        </p>
        <p class="control">
          <label class="label">Language</label>
          <select class="select is-fullwidth" v-model="agency.language" name="language" id="language">
            <option value="0">Portugues</option>
            <option value="1">Espanhol</option>
            <option value="2">Ingles</option>
          </select>
        </p>
        <p class="control">
          <label class="label">Email Voucher</label>
          <input :class="{'input': true, 'is-danger': errors.has('email_voucher'), 'is-disabled': inProgress}" type="email_voucher" name="email_voucher" id="email_voucher" placeholder="Email" v-model="agency.email_voucher">
          <span v-show="errors.has('email_voucher')" class="help is-danger">{{ errors.first('email_voucher') }}</span>
        </p>
        <p :class="{'control': true}">
          <label class="label">E-mails Invoice
            <small>Ex: separate like (support@agency.com; contact@agency.com)</small>
          </label>
          <textarea :class="{'textarea': true, 'is-danger': errors.has('emails_invoice')}" name="emails_invoice" id="emails_invoice" placeholder="E-mails" v-model="agency.emails_invoice"></textarea>
          <span v-show="errors.has('emails_invoice')" class="help is-danger">{{ errors.first('emails_invoice') }}</span>
        </p>
        <p :class="{'control': true}">
          <label class="label">E-mails Reconfirmation
            <small>Ex: separate like (support@agency.com; contact@agency.com)</small>
          </label>
          <textarea :class="{'textarea': true, 'is-danger': errors.has('emails_reconfirmation')}" name="emails_reconfirmation" id="emails_reconfirmation" placeholder="E-mails" v-model="agency.emails_reconfirmation"></textarea>
          <span v-show="errors.has('emails_reconfirmation')" class="help is-danger">{{ errors.first('emails_reconfirmation') }}</span>
        </p>
        <p :class="{'control': true}">
          <label class="label">E-mails Notification
            <small>Ex: separate like (support@agency.com; contact@agency.com)</small>
          </label>
          <textarea :class="{'textarea': true, 'is-danger': errors.has('emails_notification')}" name="emails_notification" id="emails_notification" placeholder="E-mails" v-model="agency.emails_notification"></textarea>
          <span v-show="errors.has('emails_notification')" class="help is-danger">{{ errors.first('emails_notification') }}</span>
        </p>
          <p :class="{'control': true}">
          <label class="label">Annotations
          </label>
          <textarea :class="{'textarea': true}" name="annotations" id="annotations" placeholder="" v-model="agency.annotations"></textarea>
        </p>
        <p class="control" v-show="parseInt(context.$store.state.config.user.level) < 4">
          <label class="checkbox">
            <input type="checkbox" v-model="agency.cancel_multiple">
            Cancel Bookings Not Equal to Confirmed
          </label>
        </p>
        <p class="control" v-show="parseInt(context.$store.state.config.user.level) < 4">
          <label class="checkbox">
            <input type="checkbox" v-model="agency.occurrence_email">
            Ticket by e-mail
          </label>
        </p>
        <p class="control" v-show="parseInt(context.$store.state.config.user.level) < 4">
          <label class="checkbox">
            <input type="checkbox" v-model="agency.cangooroo">
            Cangooroo
          </label>
        </p>
        <p class="control">
          <label class="label">Ezlink's Financial Department (Responsible for Billing)</label>
          <select
            class="select is-fullwidth"
            v-model="agency.ez_financial_email"
            name="ez_financial_email"
            id="ez_financial_email"
            disabled
          >
            <option value="financeiro3@ezlink.net.br">financeiro3@ezlink.net.br</option>
            <option value="financeiro6@ezlink.net.br">financeiro6@ezlink.net.br</option>
          </select>
        </p>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a :class="{'button': true, 'is-primary': true, 'is-disabled': inProgress }" @click="close(true)">Close</a>
          </p>
          <p class="control">
            <a :class="{'button': true, 'is-success': true, 'is-disabled': errors.any() || cepLoading, 'is-loading': inProgress}" @click="save">Save</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      context: {
        type: Object
      },
      callback: {
        type: String
      },
      title: {
        type: String
      },
      agency_id: {
        type: Number
      }
    },
    data () {
      return {
        agency: {
          id: '',
          name: '',
          cnpj: '',
          social_reason: '',
          municipal_inscription: '',
          nf: false,
          boleto: false,
          card: false,
          banco: '',
          commission: false,
          commission_value: '',
          cep: '',
          city: '',
          cmun: '',
          state: '',
          country: '',
          address: '',
          address_number: '',
          address_complement: '',
          address_neighborhood: '',
          national: 1,
          website: '',
          email: '',
          password: '',
          email_voucher: '',
          emails_reconfirmation: '',
          emails_notification: '',
          emails_invoice: '',
          ez_financial_email: '',
          user: '',
          logo: '',
          payment: 1,
          phone: '',
          emergency_phone: '',
          cancel_multiple: false,
          occurrence_email: false,
          cangooroo: false,
          language: 0,
          negativacao: 0,
          protesto: 0,
          incentive_type: 0,
          incentive_value: null,
          invoice_send: 0
        },
        showCep: true,
        cepProgress: true,
        cepLoading: false,
        users: [],
        inProgress: false,
        error: ''
      }
    },
    mounted () {
      this.showCep = this.agency.national === 1
      this.agency.ez_financial_email = 'financeiro3@ezlink.net.br'
      this.$nextTick(() => {
        if (this.agency_id) {
          this.loadData()
        } else {
          document.body.appendChild(this.$el)
        }
      })
    },
    methods: {
      setBoleto () {
        this.agency.card = false
      },
      setCard () {
        this.agency.boleto = false
      },
      nationality () {
        this.showCep = this.agency.national === 1
        this.$validator.reset()
      },
      cep () {
        this.cepProgress = true
        this.cepLoading = true
        this.context.$http.get(this.context.$store.state.config.apiURL + '/cep/' + this.agency.cep).then((response) => {
          this.inProgress = false
          this.cepProgress = false
          this.cepLoading = false
          this.agency.address = response.body.logradouro
          this.agency.city = response.body.localidade
          this.agency.state = response.body.uf
          this.agency.country = 'Brasil'
          this.agency.address_neighborhood = response.body.bairro
          this.agency.cmun = response.body.ibge
        }, (response) => {
          this.inProgress = false
          this.cepProgress = false
          this.cepLoading = false
          this.error = response.body.message
        })
      },
      close (closeOnly, result) {
        if (!closeOnly) {
          this.context[this.callback](result)
        }
        this.$el.remove()
      },
      save () {
        this.$validator.validateAll().then(() => {
          if (parseInt(this.agency.national) === 0) {
            this.agency.boleto = false
            this.agency.nf = false
          }
          if (this.errors.items.length === 0) {
            this.inProgress = true
            this.error = ''
            let url = this.context.$store.state.config.apiURL + '/agencies'
            if (this.agency_id) {
              url = this.context.$store.state.config.apiURL + '/agencies/' + this.agency_id
            }
            this.context.$http.post(url, this.agency).then((response) => {
              this.inProgress = false
              this.close(false, {ok: true, message: 'The agency ' + response.body.name + ' was successfully save'})
            }, (response) => {
              this.inProgress = false
              this.error = response.body
            })
          }
        })
      },
      loadData () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/agencies/' + this.agency_id).then((response) => {
          console.log(response.body)
          this.agency = response.body
          document.body.appendChild(this.$el)
          this.context.$http.get(this.context.$store.state.config.apiURL + '/users/agency/' + this.agency_id).then((response) => {
            this.users = response.body
            if (response.body.user_id !== null) {
              this.agency.user = response.body.user_id
            }
          }, (response) => {
          })
        }, (response) => {
        })
      }
    },
    watch: {
      'agency.national': {
        handler (newValue) {
          this.agency.ez_financial_email = newValue === '1'
            ? 'financeiro3@ezlink.net.br'
            : 'financeiro6@ezlink.net.br'
          this.showCep = newValue === '1'
        },
        immediate: true
      }
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },
      leaveClass () {
        return `${this.transition}Out`
      }
    }
  }
</script>
<style lang="scss" scoped>
  .is-title {
    text-transform: capitalize;
  }

  .panel {
    background-color: white;
    box-shadow: 0px 2px 3px rgb(167, 28, 32), 0px 0px 0px 1px rgb(167, 28, 32);
    color: #4a4a4a;
    max-width: 100%;
    position: relative;
    border: 0px;
    border-radius: 0px;
  }

  .panel-heading {
    color: #FFFFFF;
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: flex;
    min-height: 40px;
    box-shadow: 0px 1px 0px rgb(167, 28, 32), 0px 0px 0px 0px rgb(167, 28, 32);
    background-color: rgb(167, 28, 32);
    border-bottom: 0px;
    border-radius: 0px;
    font-size: 1rem;
  }
</style>



// WEBPACK FOOTER //
// Agency.vue?790994ac